<template>
  <div class="bg2">
    <!-- <Header background="#ffffff" title="退款/退货"></Header> -->
    <div class="lists">
      <div class="list">
        <div class="listTop flex-end">
          <span class="status">待出库</span>
        </div>
        <div class="listCenter">
          <img src="../../assets/my/pic@2x (1).png" alt="" />
          <div class="goods flex-between">
            <div class="goodsName">首饰</div>
            <div class="goodsNum">
              <p>￥380</p>
              <p>x 1</p>
            </div>
          </div>
        </div>
        <div class="bottom flex-between">
          <div class="price">
            <img src="../../assets/my/return_icon_small@2x.png" alt="" />
            <span> 退货退款 </span>
          </div>
          <div class="btns">
            <span>查看详情</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "",
  data() {
    return {};
  },
  computed: {},
  methods: {},
};
</script>

<style lang='less' scoped>
.lists {
  margin: 14px 16px;
  .list {
    background: #ffffff;
    box-shadow: 0px 5px 10px 0px rgba(0, 0, 0, 0.1);
    border-radius: 10px;
    padding: 0 14px;
    .listTop {
      height: 50px;
      font-size: 12px;
      .status {
        color: #fd0212;
      }
    }
    .listCenter {
      display: flex;
      align-items: flex-start;
      border-bottom: 1px solid #f0f0f0;
      img {
        width: 88px;
        height: 88px;
      }
      .goods {
        flex: 1;
        .goodsName {
          font-size: 15px;
        }
        .goodsNum {
          font-size: 13px;
          p:nth-child(2) {
            color: #919398;
            text-align: right;
          }
        }
      }
    }
    .bottom {
      .price {
        display: flex;
        justify-content: flex-end;
        align-items: center;
        font-size: 12px;
        color: #606266;
        height: 30px;
        img {
          width: 14px;
          height: 14px;
        }
        span {
          color: #999999;
          margin-left: 6px;
        }
      }
      .btns {
        height: 40px;
        display: flex;
        justify-content: flex-end;
        align-items: center;
        span {
          width: 68px;
          height: 26px;
          background: #ffffff;
          border-radius: 13px;
          border: 1px solid #fd0212;
          color: #fd0212;
          text-align: center;
          line-height: 26px;
          font-size: 12px;
          margin-left: 12px;
        }
        .status {
          background: #fd0212;
          color: #ffffff;
        }
      }
    }
  }
}
</style>
